import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, InboxIcon, UserGroupIcon, CalendarDaysIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import { HomeIcon as HomeIconSolid, InboxIcon as InboxIconSolid, UserGroupIcon as UserGroupIconSolid, CalendarDaysIcon as CalendarDaysIconSolid, Cog6ToothIcon as Cog6ToothIconSolid } from '@heroicons/react/24/solid';
import { isNavItemActive } from '@/lib/nav/active-segment';

interface BottomNavItem {
  id: string;
  label: string;
  icon: typeof HomeIcon;
  iconSolid: typeof HomeIconSolid;
  path: string;
}

const BOTTOM_NAV_ITEMS: BottomNavItem[] = [
  { id: 'home', label: 'Home', icon: HomeIcon, iconSolid: HomeIconSolid, path: '/tenant/home' },
  { id: 'inbox', label: 'Messages', icon: InboxIcon, iconSolid: InboxIconSolid, path: '/tenant/inbox/conversations' },
  { id: 'crm', label: 'Customers', icon: UserGroupIcon, iconSolid: UserGroupIconSolid, path: '/tenant/crm/follow-ups' },
  { id: 'calendar', label: 'Calendar', icon: CalendarDaysIcon, iconSolid: CalendarDaysIconSolid, path: '/tenant/calendar' },
  { id: 'settings', label: 'Settings', icon: Cog6ToothIcon, iconSolid: Cog6ToothIconSolid, path: '/tenant/settings/profile' },
];

export function MobileBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-[var(--border-subtle)] bg-[var(--bg-sidebar)] backdrop-blur-lg lg:hidden"
      aria-label="Mobile navigation"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <ul className="flex items-center justify-around px-1 py-1">
        {BOTTOM_NAV_ITEMS.map((item) => {
          const isActive = isNavItemActive(item.path, pathname);
          const Icon = isActive ? item.iconSolid : item.icon;

          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={`flex flex-col items-center gap-0.5 rounded-lg px-3 py-1.5 text-[10px] font-medium transition-colors ${
                  isActive
                    ? 'text-[var(--accent)]'
                    : 'text-[var(--text-muted)] active:bg-[var(--bg-card-hover)]'
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                <span className="leading-none">{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
